import "whatwg-fetch"
import React from "react"
import ReactDOM from "react-dom"
import Navigation from "DealerApp/Layout/Navigation/Navigation"
import { BrowserRouter } from "react-router-dom"
import Template from "component_library/styles/Template"
import LegacyHeader from "DealerApp/legacy/LegacyHeader"
import { initPosthog } from "DealerApp/helpers/initPosthog"
import { environment } from "DealerApp/constants/environment"

document.addEventListener("DOMContentLoaded", () => {
  // We include navigation for all legacy products, therefore
  // Initiate posthog for those products as well
  const addPosthog = (props) => {
    if (
      props.environment === environment.PRODUCTION &&
      props.user.accessType === "USER"
    )
      initPosthog(props.posthogApiKey, props.customerPosthogData, props.user)
  }

  const renderNavigation = () => {
    const nav = document.querySelector("[data-react-component=Navigation]")

    if (!nav) return

    const navProps = JSON.parse(nav.getAttribute("data-props"))
    const baseName = nav.getAttribute("data-base-name")
    const propsWithBaseName = { baseName: baseName, ...navProps }

    addPosthog(navProps)

    if (nav) {
      ReactDOM.render(
        <BrowserRouter>
          <Template>
            <Navigation {...propsWithBaseName} />
          </Template>
        </BrowserRouter>,
        nav
      )
    }
  }

  const renderHeader = () => {
    const header = document.querySelector("[data-react-component=Header]")

    if (!header) return

    const headerProps = JSON.parse(header.getAttribute("data-props"))
    const baseName = header.getAttribute("data-base-name")
    const propsWithBaseName = { baseName: baseName, ...headerProps }

    if (header) {
      ReactDOM.render(
        <BrowserRouter>
          <Template>
            <LegacyHeader {...propsWithBaseName} />
          </Template>
        </BrowserRouter>,
        header
      )
    }
  }

  renderNavigation()
  renderHeader()
})
